// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3_Rps","header":"ReportDetails_header__oiJNx","title":"ReportDetails_title__3UXiQ","left":"ReportDetails_left__6X9Vn"};